import React, {useContext} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {Constants} from "../common/Constants";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {GlobalContext} from "./AdminFrame";
import {useLocation} from "react-router-dom";

interface AdminHeaderTabProps {
    path: string;
    selected: boolean;
    label: string;
}

export let AdminHeader = function () {
    const context = useContext(GlobalContext);

    function logout(event: React.SyntheticEvent) {
        if (event) {
            event.preventDefault();
        }

        ApiUtility.logout()
            .then(function () {
                context.navigator.navigateTo('/login');
            })
            .catch(function (err) {
                console && console.error(err);
                MessageDisplayerUtility.error('An error occurred while logging out.');
                context.navigator.navigateTo('/login');
            });
    }

    let location = useLocation();
    let pathParts = location.pathname ? location.pathname.split('/') : [];
    let selectedPagePathSegment;
    if (pathParts.length > 1) {
        selectedPagePathSegment = pathParts[1];
    } else {
        selectedPagePathSegment = ('' + location.pathname).replace(new RegExp('/', 'g'), '')
    }

    return (
        <div className="admin-header">
            <div className="admin-header-content">
                <div className="admin-header-title-container">
                    <div className="admin-header-title">CULTIVATE BILLING</div>
                </div>

                <div className="admin-header-tabs-container">
                    <AdminHeaderTab
                        label="INVOICE PAYMENT SETTINGS"
                        selected={selectedPagePathSegment === Constants.pagePathSegments.invoicePaymentSettings}
                        path={`/${Constants.pagePathSegments.invoicePaymentSettings}`}
                    />
                    <AdminHeaderTab
                        label="FP-QBO INTEGRATION"
                        selected={selectedPagePathSegment === Constants.pagePathSegments.fpQboIntegration}
                        path={`/${Constants.pagePathSegments.fpQboIntegration}`}
                    />
                    <AdminHeaderTab
                        label="INVOICES"
                        selected={selectedPagePathSegment === Constants.pagePathSegments.invoices}
                        path={`/${Constants.pagePathSegments.invoices}`}
                    />
                    <AdminHeaderTab
                        label="SUBSCRIPTIONS"
                        selected={
                            selectedPagePathSegment === Constants.pagePathSegments.subscriptions ||
                            selectedPagePathSegment === Constants.pagePathSegments.subscriptionInvoices
                        }
                        path={`/${Constants.pagePathSegments.subscriptions}`}
                    />
                    <AdminHeaderTab
                        label="USERS"
                        selected={selectedPagePathSegment === Constants.pagePathSegments.users}
                        path={`/${Constants.pagePathSegments.users}`}
                    />
                </div>

                <div className="admin-header-account-info-container">
                    <div className="admin-header-account-info">
                        <div
                            className="admin-header-username-display"
                        >Logged in as {document.querySelector('.logged-in-user-name')?.textContent}
                        </div>
                        <div className="logout-option-container">
                            <div
                                className="logout-option"
                                onClick={logout}
                            >LOGOUT
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

let AdminHeaderTab = function (props: AdminHeaderTabProps) {
    const context = useContext(GlobalContext);

    function onClick() {
        context.navigator.navigateTo(props.path);
    }

    let tabClasses = "admin-header-tab ";
    if (props.selected) {
        tabClasses += "selected";
    }

    return (
        <div
            onClick={onClick}
            className={tabClasses}
        >
            <div
                className="admin-header-tab-text"
            >{props.label}</div>
            <div className="admin-header-tab-underline"></div>
        </div>
    );
};
